// Project Imports
import ResourceItem from 'interfaces/resource';
import resourceName from 'core/common/resourceName';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const img = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00391 11.9766C2.69141 11.9766 0 14.668 0 17.9805C0 18.3711 0.316406 18.6875 0.707031 18.6875H11.293C11.6836 18.6875 12 18.3711 12 17.9805C12.0039 14.668 9.3125 11.9766 6.00391 11.9766ZM1.47266 17.2695C1.86328 14.7695 4.21094 13.0586 6.71094 13.4492C8.67969 13.7578 10.2227 15.3008 10.5312 17.2695H1.47266Z"
      fill="currentColor"
    />
    <path
      d="M6.00391 10.5977C7.625 10.5977 8.94141 9.28125 8.94141 7.66016C8.94141 6.03906 7.625 4.72266 6.00391 4.72266C4.38281 4.72266 3.06641 6.03906 3.06641 7.66406C3.06641 9.28516 4.38281 10.5977 6.00391 10.5977ZM6.00391 6.14453C6.84375 6.14453 7.52344 6.82422 7.52344 7.66406C7.52344 8.50391 6.84375 9.18359 6.00391 9.18359C5.16406 9.18359 4.48438 8.50391 4.48438 7.66406C4.48438 6.82422 5.16406 6.14453 6.00391 6.14453Z"
      fill="currentColor"
    />
    <path
      d="M19.9453 0.4375C19.8359 0.171875 19.5781 0 19.2891 0L8.8125 0.00781253C8.42188 0.00781253 8.10547 0.324219 8.10547 0.71875C8.10547 0.90625 8.17969 1.08203 8.30859 1.21484L11.9922 4.95312V8.92578C11.9922 9.16797 12.1172 9.39453 12.3203 9.52344L14.9844 11.2109C15.3125 11.4219 15.7539 11.3242 15.9609 10.9961C16.0352 10.8828 16.0703 10.75 16.0703 10.6133V4.92578L19.7891 1.20703C19.9961 1.00781 20.0547 0.703125 19.9453 0.4375ZM14.8633 4.13281C14.7305 4.26562 14.6562 4.44531 14.6562 4.63281V9.32812L13.4102 8.53906V4.66406C13.4102 4.47656 13.3359 4.30078 13.207 4.16797L10.5078 1.42578L17.5781 1.41797L14.8633 4.13281Z"
      fill="currentColor"
    />
  </svg>
);
const AudienceGrouping: ResourceItem = {
  name: resourceName.audienceGrouping,
  identifier: ModuleIdentifierConst.AUDIENCE_GROUPING,
  list: `${resourceName.audienceGrouping}`,
  show: `${resourceName.audienceGrouping}/show/:id`,
  create: `${resourceName.audienceGrouping}/create`,
  edit: `${resourceName.audienceGrouping}/edit/:id`,
  options: { label: 'Audience Grouping', icon: img },
};

export default AudienceGrouping;
